@for (value of enumValues; track value) {
  <div>
    <div class="love-it-checkbox">
      <input
        type="checkbox"
        class="form-check-input"
        [id]="unique + value"
        [formControl]="formControls.get(value)" />
      <label
        class="form-check-label"
        [for]="unique + value"
        >{{ value }}</label
      >
    </div>
  </div>
}
